const local = '_PROVIDER_ROTAER_FOLLOWAIR_'
import Vue from 'vue'
import { compress, decompress } from 'lz-string'
var update = false

export default {
	methods: {
		_GET_ROTAER: function (callback) {
			this._httpGet('/Rotaer/get_rotaer', function (retorno) {
				if (retorno._request && retorno._status) {
					callback(retorno.lista.length > 0 ? retorno.lista : null)
				} else {
					callback(null)
				}
			})
		},

		_providerRotaerUpdate: function (load) {
			if (load) {
				bus.$emit('load-in', {text: 'Atualizado cache'})
			}

			this._GET_ROTAER(function (lista) {
				if (load) {
					bus.$emit('load-out')
				}

				if (lista != null) {
					var string = JSON.stringify(lista)
					sessionStorage.setItem(local, compress(string))
				}
			})
		},

		_providerRotaer: function (callback) {
			if (!update) {
				update = true
				this._GET_ROTAER(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, compress(string))
						callback(lista)
					} else {
						callback([])
					}
				})
			}

			// se existir config do cliente
			if (sessionStorage.getItem(local) != null) {
				callback(JSON.parse(decompress(sessionStorage.getItem(local))))
			} else {
				this._GET_ROTAER(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, compress(string))
						callback(lista)
					} else {
						callback([])
					}
				})
			}
		}
	}
}